import Interfaces from "./_interfaces";
import Modal from "./_bootstrapModalExtensions";
import NotificationUtil from "./_notificationUtil";

import * as UrlUtil from "./Utils/UrlUtil";

import * as Intro from "./Intros/_IntroBase";
import * as AddrelatedProcessIntro from './Intros/_addRelatedProcess';

import * as DxFilterDate from "./_dateFilterPanel";

let isProcessListForProcessSelectCallbackPending: boolean = false;
let firstToggle: boolean = true;

export function OnProcessListSelectPartialInit(s: MVCxClientGridView, e: ASPxClientEventArgs, shouldAutoRun: boolean) {
    $('.search-bar-section').hide();

    let processEstate: string = $('#settlement-name-input').data('process-estate');
    $('#settlement-name-input').val(processEstate);

    s.Refresh();

    if (shouldAutoRun === true) {
        Intro.AutoRunIntro(() => AddrelatedProcessIntro.addRelatedProcessStartIntro(), 'addRelatedProcessIntro');
    }
}

export function ProcessSelectOnBeginCallback(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    isProcessListForProcessSelectCallbackPending = true;

    DxFilterDate.CheckAndCorrectDateFilterValues();

    let haveToFilterToCurrentProcessEstate: string = $('#toggle-process-filter').attr('data-have-to-filter');
    let fromDate: string = $('.dfflt-from').val() as string;
    let toDate: string = $('.dfflt-to').val() as string;

    // Additional parameters are loaded from the fields directly each time DX performs a callback
    // Read the current parameter and store it for the callback process
    e.customArgs['haveToFilterToCurrentProcessEstate'] = haveToFilterToCurrentProcessEstate === 'true' ? true : false;
    e.customArgs['settlementName'] = $('#settlement-name-input').val();
    e.customArgs['fromDate'] = haveToFilterToCurrentProcessEstate === 'true' ? null : fromDate;
    e.customArgs['toDate'] = haveToFilterToCurrentProcessEstate === 'true' ? null : toDate;

    s.SetFocusedRowIndex(-1);
    $('#processSelectButton').attr('data-selected-processid', '').prop('disabled', true);
}

export function ProcessSelectOnEndCallback(s: Interfaces.MVCxClientGridViewWithFilterStatusInfo, e: MVCxClientBeginCallbackEventArgs) {
    // Display filter alert if necessary
    ToggleAlertVisibilityForProcessSelectList(s);

    isProcessListForProcessSelectCallbackPending = false;
}

export function OnGridFocusedRowChangedOnProcessSelectPage(s: MVCxClientGridView, e: ASPxClientGridViewFocusEventArgs) {
    let sor: number = s.GetFocusedRowIndex();

    // This event also fires when the page loads. At that moment there isn't any focused row, so return
    if (sor === -1) {
        return;
    }

    // Get the selected process' Id
    let selectedProcessId: string = s.GetRowKey(sor) || '0';

    // Store the selected process' Id
    $('#processSelectButton').attr('data-selected-processid', selectedProcessId).removeAttr('disabled');
}

export function OnProcessSelectChooseButtonClicked() {
    let urlTemplate: string, url: string;
    let processId: string = $('#processSelectButton').data('processid');
    let selectedProcessId: string = $('#processSelectButton').data('selected-processid');
    let selectType: string = $('#processSelectButton').data('select-type');

    // Decide which url to generate
    if (selectType === 'processPartnerCopy') {
        urlTemplate = window.ETDR_RD.appConfig['UrlTemplate.ProcessSelectForProcessPartnerCopy'];

        Modal.showConfirmationWindowAsync(
            'Biztosan másolni szeretné az eljárás érintettjeit?',
            'Megerősítés',
            () => { location.href = UrlUtil.createUrlFromTemplate(urlTemplate, { processId: processId, selectedProcessId: selectedProcessId }); },
            () => { return false; },
            'Igen',
            'Nem')
    } else if (selectType === 'relatedProcess') {
        urlTemplate = window.ETDR_RD.appConfig['UrlTemplate.ProcessSelectForRelatedProcess'];
        location.href = UrlUtil.createUrlFromTemplate(urlTemplate, { processId: processId, selectedProcessId: selectedProcessId });
    } else {
        return false;
    }
}

export function ToggleProcessFilter(event: JQuery.TriggeredEvent) {
    let $toggleButton: JQuery = $(event.target);

    // Swap the values (toggle)
    let haveToFilterToCurrentProcessEstate: boolean = $toggleButton.attr('data-have-to-filter') === 'true' ? false : true;

    // Hide or show the search panel
    if (haveToFilterToCurrentProcessEstate) {
        $('.search-bar-section').hide();
    } else {
        $('.search-bar-section').show();
    }

    let buttonText: string = haveToFilterToCurrentProcessEstate
        ? 'Az összes eljárás megjelenítése'
        : 'Tárgyi ingatlanra szűrt eljárások megjelenítése';

    // Store the new value, so the OnBeginCallback function (ProcessSelectOnBeginCallback) will be able to get this
    $toggleButton.text(buttonText).attr('data-have-to-filter', String(haveToFilterToCurrentProcessEstate));

    // Initiate grid callback
    let grid: MVCxClientGridView = window['ProcessListForProcessSelectPartial'] as MVCxClientGridView;
    grid.Refresh();
}

function ToggleAlertVisibilityForProcessSelectList(grid: Interfaces.MVCxClientGridViewWithFilterStatusInfo) {
    let searchPanelFilter: string = grid.cpSearchPanelFilter;
    let haveToFilterToCurrentProcessEstate: boolean = $('#toggle-process-filter').attr('data-have-to-filter') === 'true';

    if ((!haveToFilterToCurrentProcessEstate && (searchPanelFilter || grid.cpIsRowFilteringActive))
        || (haveToFilterToCurrentProcessEstate && grid.cpIsRowFilteringActive)) {
        $('#gridview-alert-bar').show();
    } else {
        $('#gridview-alert-bar').hide();
    }
}

export function ClearProcessListSelectFilters(gridName: string) {
    if (isProcessListForProcessSelectCallbackPending) {
        return;
    }

    let grid: Interfaces.MVCxClientGridViewWithFilterStatusInfo = window[gridName] as Interfaces.MVCxClientGridViewWithFilterStatusInfo;

    // Clear the searchpanel's value
    grid.ApplySearchPanelFilter('');

    // Clear the settlement filter's value
    let haveToFilterToCurrentProcessEstate: boolean = $('#toggle-process-filter').attr('data-have-to-filter') === 'true';

    if (!haveToFilterToCurrentProcessEstate) {
        $('#settlement-name-input').val('');
    }

    // Clear the row filter (if filtering is active) this will reload the grid also        
    if (grid.cpIsRowFilteringActive) {
        grid.ClearFilter();
    }

    if (grid.cpIsSearchPanelFilteringActive) {
        grid.ApplySearchPanelFilter('');
    }

    if (!grid.cpIsRowFilteringActive && !grid.cpIsSearchPanelFilteringActive) {
        grid.Refresh();
    }
}

export function ClearProcessListSelectFiltersOnToggle() {
    if (!firstToggle) {
        // Clear the settlement filter's value
        $('#settlement-name-input').val('');

        let grid: Interfaces.MVCxClientGridViewWithFilterStatusInfo = window['ProcessListForProcessSelectPartial'] as Interfaces.MVCxClientGridViewWithFilterStatusInfo;

        // Clear the row filter (if filtering is active) this will reload the grid also        
        if (grid.cpIsRowFilteringActive) {
            grid.ClearFilter();
        }

        if (grid.cpIsSearchPanelFilteringActive) {
            grid.ApplySearchPanelFilter('');
        }
    }

    firstToggle = false;
}

export function OnRDFormerETDRProcessSelected(event: JQuery.ClickEvent) {
    let grid: MVCxClientGridView = window['RDProcessListForSelectPartial'] as MVCxClientGridView;
    let processId: string = $(event.target).data('process-id');
    let selectedProcessId: number = grid.GetSelectedKeysOnPage()[0] as number;

    if (!processId) {
        NotificationUtil.Error('Hiba történt! Töltse újra az oldalt, vagy keresse fel az ügyfélszolgálatot!');
        return;
    }

    if (!selectedProcessId) {
        NotificationUtil.Info('A mentéshez előbb válasszon eljárást!');
        return;
    }

    let urlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.FormerProcessSelected"];
    let url: string = UrlUtil.createUrlFromTemplate(urlTemplate, { processId: processId, selectedProcessId: selectedProcessId });

    location.href = url.toString();
}

jQuery(() => {
    $('#processSelectButton').click(() => OnProcessSelectChooseButtonClicked());

    $('#toggle-process-filter').click((event) => { ToggleProcessFilter(event); ClearProcessListSelectFiltersOnToggle(); });

    $('#processlistforselect-clear-filter').click(() => ClearProcessListSelectFilters("ProcessListForProcessSelectPartial"));

    $(document).on('click', '#former-rd-process-select-btn', (event: JQuery.ClickEvent) => OnRDFormerETDRProcessSelected(event));
});
